module.exports = __webpack_public_path__ + "img/crystal_23_a.eadeb657.jpg";